// extracted by mini-css-extract-plugin
export default {"container":"ChangePassword_container__YcOlz"};